<template>
  <modal @close="close" width="90%">
    <md-toolbar :class="headerClass" md-elevation="1" slot="header">
      <h3 class="text-center md-title">
        <md-icon>
          {{ realPlan.planExpected.status | planIcon }}
        </md-icon>
        Evidencias | {{ realPlan.planExpected.sinisterNumber }} |
        {{ hasRequiredPhotos | statusMessage }}
      </h3>
    </md-toolbar>

    <photo-evidences
      slot="body"
      :affectedId="affectedId"
      @uploadedPhotos="$emit('uploadedPhotos')"
      @hasRequiredPhotos="hasRequiredPhotos = $event"
      :no-image-actions="isExtranet"
      :is-extranet="isExtranet"
      :check-date="realPlan.date"
      v-if="affectedId"
      :read-only="realPlan.readOnly || isExtranet"
      :isES="!realPlan.readOnly"
      :isCP="false"
      show-panoramic-reject
      :realPlan="realPlan"
    />

    <md-button @click="close" slot="footer"> Cancelar </md-button>
  </modal>
</template>

<script>
import PhotoEvidences from "./../PhotoEvidences";
import { TASK_STATUS_ICONS } from "./utils";

export default {
  name: "PhotoEvidencesModal",

  props: {
    realPlan: {
      type: Object,
      required: true
    },
    isExtranet: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    sinisterId() {
      const realPlan = this.realPlan;
      const planExpected = realPlan && realPlan.planExpected;
      return planExpected && planExpected.sinisterId;
    },
    affectedId() {
      const realPlan = this.realPlan;
      const planExpected = realPlan && realPlan.planExpected;
      return planExpected && planExpected.affectedId;
    },
    headerClass() {
      const { hasRequiredPhotos } = this;
      if (hasRequiredPhotos) {
        return "md-success";
      } else if (hasRequiredPhotos === false) {
        return "md-warning";
      }
    }
  },

  components: {
    PhotoEvidences
  },

  methods: {
    close() {
      this.$emit("close");
    }
  },

  data() {
    return {
      securityPhotos: [],
      hasRequiredPhotos: null
    };
  },

  filters: {
    planIcon(status) {
      return TASK_STATUS_ICONS[status] || "visibility";
    },
    statusMessage(evidencesStatus) {
      if (evidencesStatus) {
        return "Tiene todas las evidencias";
      } else if (evidencesStatus === false) {
        return "Faltan evidencias";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/PhotoEvidencesModal.vue